import { useEffect, useState } from "react";
import apiPath from "../../Utils/apiPath";
import { apiGet } from "../../Utils/apiFetch";
import { isEmpty, startCase } from "lodash";
import moment from "moment/moment";
import { t } from "i18next";
import NoData from "../../component/NoData";
import BettingSettledDetail from "./BettingSettledDetail";
import BettingUnSettledDetail from "./BettingUnSettledDetail";
const BettingUnSettled = () => {
  const [parly, setParly] = useState([]);
  const [data, setData] = useState([]);
  const [single, setSingle] = useState({});
  const mergeAllBetsWithGameType = (arr) => {
    const keys = [
      "betList",
      "bookmakerList",
      "sessionBetList",
      "sportBookBetList",
    ];

    let Mark = {
      betList: "Match Odds",
      bookmakerList: "Bookmaker",
      sessionBetList: "Fancy Bet",
      sportBookBetList: "Sport Book",
    };
    return arr.flatMap((obj) =>
      keys.flatMap((key) =>
        (obj[key] || []).map((item) => ({
          ...item, // Copy bet data
          gameType: startCase(obj.gameType), // Add gameType
          showType: Mark[key], // Add array name
        })),
      ),
    );
  };

  const getCurrentBets = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.mobileCurrentBets,
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users?.results?.length > 0) {
          // setData(mergeAllBetsWithGameType(response_users?.results));
          setData(response_users?.results);
        }
      }
    }
  };
  const getParlyBet = async () => {
    const { status, data } = await apiGet(apiPath.getParlyBets);
    if (status == 200) {
      if (data?.success) {
        setParly(data?.data?.data);
      }
    }
  };
  useEffect(() => {
    getCurrentBets();
    // getParlyBet();
  }, []);
  return parly?.length > 0 || data?.length > 0 ? (
    isEmpty(single) ? (
      <app-waterfall-scroll
        _ngcontent-serverapp-c3596067515
        _nghost-serverapp-c302379289
        className="ng-tns-c3596067515-51 ng-star-inserted"
      >
        <div
          _ngcontent-serverapp-c3068904919
          className="list-title ng-tns-c3068904919-124"
        >
          <div
            _ngcontent-serverapp-c3068904919
            className="list-field profit ng-tns-c3068904919-124"
          >
            Event Name
          </div>
          <div
            _ngcontent-serverapp-c3068904919
            className="list-field profit ng-tns-c3068904919-124"
          >
            Sports Type
          </div>{" "}
          <div
            _ngcontent-serverapp-c3068904919
            className="list-field profit ng-tns-c3068904919-124"
          >
            Total Bets
          </div>
        </div>
        {data?.length > 0 &&
          data?.map((res) => {
            return (
              <div
                _ngcontent-serverapp-c3068904919
                className="list-group ng-tns-c3068904919-58 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
              >
                <ul
                  _ngcontent-serverapp-c3068904919
                  className="list-content ng-tns-c3068904919-58"
                >
                  <li
                    onClick={() => setSingle(res)}
                    _ngcontent-serverapp-c3068904919
                    className="ng-tns-c3068904919-58 ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c3068904919
                      className="list-field profit ng-tns-c3068904919-58"
                    >
                      {res?.eventName}
                    </div>
                    <div
                      _ngcontent-serverapp-c3068904919
                      className={`list-field profit ng-tns-c3068904919-58`}
                    >
                      {startCase(res?.gameType)}
                    </div>{" "}
                    <div
                      _ngcontent-serverapp-c3068904919
                      className={`list-field profit ng-tns-c3068904919-58`}
                    >
                      {res?.sportBookBetList?.length +
                        res?.sessionBetList?.length +
                        res?.bookmakerList?.length +
                        res?.betList?.length}
                    </div>
                    <div
                      _ngcontent-serverapp-c3068904919
                      className="list-arrow ng-tns-c3068904919-58"
                      style={{
                        "mask-image":
                          'url("/assets/Other/icon-arrow-type01.svg")',
                      }}
                    />
                  </li>
                </ul>
              </div>
            );
          })}
        {/* <ul
        _ngcontent-serverapp-c3596067515
        className="list-content ng-tns-c3596067515-51 ng-star-inserted"
      >
        {parly?.length > 0 &&
          parly?.map((res) => {
            return (
              <li
                _ngcontent-serverapp-c3596067515
                className="ng-tns-c3596067515-51 ng-star-inserted"
              >
                <div
                  _ngcontent-serverapp-c3596067515
                  className="list-field platform ng-tns-c3596067515-51"
                >
                  9 WICKETS
                </div>
                <div
                  _ngcontent-serverapp-c3596067515
                  className="list-field type ng-tns-c3596067515-51"
                >
                  Sport
                </div>
                <div
                  _ngcontent-serverapp-c3596067515
                  className="list-field game ng-tns-c3596067515-51"
                >
                  Parlay -{" "}
                  {res?.bets?.length == 1
                    ? "SINGLE"
                    : res?.bets?.length == 2
                    ? "DOUBLE"
                    : res?.bets?.length == 3
                    ? "TREBLE"
                    : "ACCUMLATOR"}
                </div>
                <div
                  _ngcontent-serverapp-c3596067515
                  className="list-field bet ng-tns-c3596067515-51"
                >
                  <i
                    id="locale-util-dicrective-18"
                    className="ng-tns-c3596067515-51"
                    style={{ display: "initial" }}
                  >
                    ৳{res?.amount}
                  </i>
                </div>
              </li>
            );
          })}
        {data?.length > 0 &&
          data?.map((res) => {
            return (
              <li
                _ngcontent-serverapp-c3596067515
                className="ng-tns-c3596067515-51 ng-star-inserted"
              >
                <div
                  _ngcontent-serverapp-c3596067515
                  className="list-field platform ng-tns-c3596067515-51"
                >
                  Exchange
                </div>
                <div
                  _ngcontent-serverapp-c3596067515
                  className="list-field type ng-tns-c3596067515-51"
                >
                  Sport
                </div>
                <div
                  _ngcontent-serverapp-c3596067515
                  className="list-field game ng-tns-c3596067515-51"
                >
                  {res?.showType} -{res?.gameType}
                </div>
                <div
                  _ngcontent-serverapp-c3596067515
                  className="list-field bet ng-tns-c3596067515-51"
                >
                  <i
                    id="locale-util-dicrective-19"
                    className="ng-tns-c3596067515-51"
                    style={{ display: "initial" }}
                  >
                    ৳{res?.amount}
                  </i>
                </div>
              </li>
            );
          })}
      </ul> */}
      </app-waterfall-scroll>
    ) : (
     <BettingUnSettledDetail
          data={single}
          setSingle={setSingle}
        />
    )
  ) : (
    <NoData />
  );
};

export default BettingUnSettled;
